import { render, staticRenderFns } from "./ImageMasonry.vue?vue&type=template&id=2998dc2c&scoped=true&"
import script from "./ImageMasonry.vue?vue&type=script&lang=ts&"
export * from "./ImageMasonry.vue?vue&type=script&lang=ts&"
import style0 from "./ImageMasonry.vue?vue&type=style&index=0&id=2998dc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998dc2c",
  null
  
)

export default component.exports